import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import MUITable from "../MUITable/MUITable";
import moment from "moment";
import { withRouter } from "react-router";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';
import { sortCompareDate } from "../../utils/TableHelper";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class AdminHome extends Component {

  componentDidMount() {
    this.props.dispatch({ type: "GET_STUDENTS" });
    this.props.dispatch({ type: "GET_ADMIN" });
    this.props.dispatch({ type: "FETCH_ENTRIES_FOR_ADMIN" });
  }

  render() {
    const columns = [
      {
        name: "Edit",
        label: " ",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRenderLite: (dataIndex) => this.renderUpdateButton(dataIndex)
        }
      },
      { name: "First Name", options: { filter: true } },
      { name: "Last Name", options: { filter: true } },
      { name: "Last Login", options: { filter: true } },
      { name: "Grade", options: { filter: false } },
      { name: "Grad Year", options: { filter: true } },
      { name: "School", options: { filter: true } },
      { name: "ID", options: { filter: true } },
      { name: "Start Date", options: { filter: true, sortCompare: sortCompareDate } },
      { name: "Student Email", options: { filter: true } },
      { name: "PIF", options: { filter: true } },
      { name: "Debt", options: { filter: true } },
      {
        name: "Savings",
        headerClassName: "MUIDataTableHeadCell-contentWrapper-56",
        options: {
          filter: true,
          sort: true,
          customBodyRenderLite: (dataIndex) => this.renderLinkToHistory(dataIndex),
          setCellProps: value => ({
            style: { paddingRight: '18px' }
          }),
          setCellHeaderProps: value => ({
            style: { float: 'right', textAlign: 'right' }
          }) 
        }
      }
    ];

    const changeInactiveDisplay = () => {
      if (!this.state)
        this.setState({isChecked: true});
      else
        this.setState({isChecked: !this.state.isChecked});
    }

    return (
      <div>
        {this.props.user.role === "admin" && (
          <div className="navbuttonscontainer">
            <Link to="/addstudent">
              <Button variant="success" style={{margin:'10x'}}>Add New Student</Button>
            </Link>
            <div style={{float: 'right', margin:'12px 25px 0px 0px'}}>
              <input type="checkbox" id="display-inactive" onChange={changeInactiveDisplay}></input>
              <label for="display-inactive">Show Inactive Students</label>
            </div>
          </div>
        )}
        <div className="dense-table">
          <MUITable
            data={this.getStudentArray(this.props.students)}
            columns={columns}
            title={"LCF Student List"} />
        </div>
      </div>
    );
  }

  goToEditStudent(lcf_id) {
    this.props.history.push({pathname: `/updatestudent/${lcf_id}`});
  }
  goToUpdatePassword(lcf_id) {
    this.props.history.push(`/updatepassword/${lcf_id}`);
  }

  renderUpdateButton = (dataIndex) => {
    const studentsArray = this.filterStudentArray(this.props.students);
    const student = studentsArray[dataIndex];
    if (!student) {
      return <div></div>
    }
    const isActive = student.inactive === "no";
    const busy = this.props.busyStudentIds.has(student.lcf_id);
    if (busy) {
      return (<div style={{ width: '140px' }} className="text-center">
        <Spinner animation="border" size="sm" variant="primary" />
      </div>);
    }
    if (!isActive) {
      return (
        <div style={{ width: '140px' }} className="text-center">
          <Button
            variant="info" size="sm" disabled={busy}
            onClick={(event) => {
              event.preventDefault();
              this.props.dispatch({ type: "ACTIVATE_STUDENT", payload: { lcf_id: student.lcf_id } });
            }}>
            Reactivate
          </Button>
        </div>
      );
    } else {
      return (
        <div style={{ width: '140px' }} className="text-center">
          <Button
            title="Edit Student"
            variant="primary" size="sm"
            disabled={busy}
            onClick={() => this.goToEditStudent(student.lcf_id)}>
            <EditIcon fontSize="small"></EditIcon>
          </Button>
          <Button
            title="Reset Password"
            variant="primary" size="sm" className="ml-1"
            disabled={busy}
            onClick={() => this.goToUpdatePassword(student.lcf_id)}>
            <RotateLeftIcon fontSize="small"></RotateLeftIcon>
          </Button>
          <Button
             title="Deactivate Student"
              variant="danger" size="sm" className="ml-1"
              disabled={busy}
              onClick={() => {
                this.props.dispatch({ type: "DEACTIVATE_STUDENT", payload: { lcf_id: student.lcf_id } });
              }}>
              <BlockIcon fontSize="small" />
            </Button>
        </div>
      );
    }
  }

  renderLinkToHistory = (dataIndex) => {
    const studentsArray = this.filterStudentArray(this.props.students);
    const student = studentsArray[dataIndex];
    if (!student) {  // student may be null for an instant when deactivating
      return (<></>);
    }
    return (
      <div className="text-center">
        <Link to={`/transaction-history/${student.lcf_id}`} style={{ float: 'right' }}>
          {student.total_amount}
          <ArrowBackIcon style={{transform: 'rotate(180deg)', fontSize: 'small', margin: '0px 0px 3px 4px'}}/>
        </Link>
      </div>
    );
  }

  filterStudentArray = (students) => {
    students = students || this.props.students;
    return students.filter(
      (entry) =>
        entry.first_name &&
        entry.last_name &&
        entry.grade &&
        entry.grad_year &&
        entry.school_attend &&
        entry.lcf_id &&
        moment.utc(entry.lcf_start_date).format("MMMM Do YYYY") &&
        entry.student_email &&
        entry.password &&
        entry.balance_due &&
        entry.pif_amount &&
        (entry.inactive === 'no' || this.showInactive())
    );
  };

  // this IS A SELECTOR: it takes some state, and it
  // returns some derived state. In other words, if you
  // have students, you can always calculate the array
  // that MUI needs from there.
  getStudentArray = (students) => {
    const studentsArray = this.filterStudentArray(students).map(
      (entry) => [
        entry.first_name, // 0
        entry.last_name, // 1
        entry.last_login == null ? <>Hasn't logged in</> : moment.utc(entry.last_login).fromNow(),
        Number(entry.grade), // 2
        entry.grad_year, // 3
        entry.school_attend, // 4
        entry.lcf_id, // 5
        moment.utc(entry.lcf_start_date).format("M/D/YY"),
        entry.student_email,
        //entry.password,
        entry.pif_amount,
        entry.balance_due,
        entry.total_amount,
      ]
    );
    return studentsArray;
  };

  showInactive() {
    if (this.state === null) {
      return false;
    }
    return this.state.isChecked;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  students: state.students.studentlist,
  busyStudentIds: state.students.busyStudentIds
});


export default withRouter(connect(mapStateToProps)(AdminHome));
